import React from "react";
import { Form, Input, InputNumber, Button } from "antd";
import { flooringUseMutation } from "../../hooks";
import { Localize } from "components/service";
import { TFlooringVariation } from "../../helpers/flooring-variation-types-helper";
import FlooringVariationFormFields from "../fields";
import Icons from "components/icons";
import Flooring from "components/flooring";
import { useModelFormValidation } from "components/permissions";

interface IFlooringVariationEditFormProps
{
  flooringID: string;
  variation?: TFlooringVariation;
  variables: Record<string, any>;
  action: () => void;
}

const FlooringVariationEditForm: React.FC<IFlooringVariationEditFormProps> = ({
  flooringID,
  variation,
  variables,
  action,
}) =>
{
  const [ form ] = Form.useForm();

  const {
    _setFlooringVariationCreateUpdate,
    loadingMutationFlooringVariationCreateUpdate,
  } = flooringUseMutation.variationCreateUpdate(variation?.id, variables);

  const { validateUpdatePermission } = useModelFormValidation(Flooring.Const);

  return (
    <Form
      key="edit-flooring-variation-form"
      layout="vertical"
      form={form}
      className="model-form edit-flooring-variation-form"
      onFinish={(values) =>
      {
        if (!validateUpdatePermission()) {
          return;
        }

        _setFlooringVariationCreateUpdate({
          variables: {
            input: {
              id: variation?.id ? +variation.id : undefined,
              flooring_id: flooringID,
              ...values,
            },
          },
        });
        action();
        form.resetFields();
      }}
    >
      <Form.Item
        name="title"
        label={<Localize>FORMS.Input_Label_Name</Localize>}
        initialValue={variation?.title}
        rules={[
          {
            required: true,
            message: <Localize>FORM_RULES.Required_Name</Localize>,
          },
        ]}
      >
        <Input name="title" />
      </Form.Item>

      <FlooringVariationFormFields.OrganizerSelect
        form={form}
        variation={variation}
        rules={[
          {
            required: true,
            message: <Localize>FORM_RULES.Required_Organizer</Localize>,
          },
        ]}
      />

      <Form.Item
        name="article"
        label={<Localize>FORMS.Input_Label_Article</Localize>}
        initialValue={variation?.article}
        rules={[
          {
            required: true,
            message: <Localize>FORM_RULES.Required_Article</Localize>,
          },
        ]}
      >
        <Input name="article" />
      </Form.Item>

      <div className="row-grid grid-gap-10 row-gap-0 col-md-2">
        <Form.Item
          name="price"
          label={<Localize>TABLES.Column_Title_WholePrice</Localize>}
          initialValue={variation?.price}
          rules={[
            {
              required: true,
              message: <Localize>FORM_RULES.Required_Price</Localize>,
            },
          ]}
        >
          <InputNumber name="price" min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="price_basic"
          label={<Localize>TABLES.Column_Title_BasicFlooringPrice</Localize>}
          initialValue={variation?.price_basic}
          rules={[
            {
              required: true,
              message: <Localize>FORM_RULES.Required_Price</Localize>,
            },
          ]}
        >
          <InputNumber name="price_basic" min={0} style={{ width: "100%" }} />
        </Form.Item>
      </div>

      <div className="form-btn-holder">
        <Button className="light-bg" onClick={action}>
          <Localize>GLOBAL.Button_Text_Cancel</Localize>
        </Button>
        <Button
          className="btn-right"
          type="primary"
          htmlType="submit"
          icon={variation?.id ? <Icons.Edit /> : <Icons.Plus />}
          loading={loadingMutationFlooringVariationCreateUpdate}
        >
          <span className="ellipsis">
            {variation?.id ? (
              <Localize>GLOBAL.Button_Text_SaveChanges</Localize>
            ) : (
              <Localize>GLOBAL.Button_Text_Create</Localize>
            )}
          </span>
        </Button>
      </div>
    </Form>
  );
};

export default FlooringVariationEditForm;
